import React from 'react';
import { useTranslation } from 'react-i18next';
import { BathtubIcon } from '@fronton/icons-react';
import { DesignRegistrationPanel } from 'common/components';
import { BATHROOM_REPAIR_ELEMENT_BLOCK } from '../../bathroom-repair-constants';

type BathroomRepairDesignPanelProps = {
  designSignHref: string;
};

export const BathroomRepairDesignPanel: React.FC<BathroomRepairDesignPanelProps> = ({ designSignHref }) => {
  const { t } = useTranslation();

  return (
    <DesignRegistrationPanel
      structure={{
        panel: {
          content: {
            leftIcon: BathtubIcon,
            iconColor: 'text-invert',
            iconType: 'duotone',
            text: t('design-panel.text'),
          },
          actionBlock: [
            {
              elementBlock: BATHROOM_REPAIR_ELEMENT_BLOCK,
              href: designSignHref,
              label: t('design-panel.button'),
              target: '_blank',
              variant: 'accent',
            },
          ],
        },
        mobilePanel: {
          mobileButton: {
            elementBlock: BATHROOM_REPAIR_ELEMENT_BLOCK,
            label: t('design-panel.button'),
            href: designSignHref,
          },
          content: {
            icon: BathtubIcon,
            iconColor: 'text-invert',
            iconType: 'duotone',
            text: t('design-panel.text') || '',
          },
          actionBlock: [],
        },
      }}
    />
  );
};
